/* Keep anatomical enlargements current when Dawn re-renders their section. */
(() => {
  if (customElements.get('hm-knee-detail')) return;
  customElements.whenDefined('modal-dialog').then(() => {
    if (customElements.get('hm-knee-detail')) return;
    const DawnModal = customElements.get('modal-dialog');
    class KneeDetail extends DawnModal {
      connectedCallback() {
        if (this.moved) return;
        document.querySelectorAll('hm-knee-detail').forEach((previous) => {
          if (previous !== this && previous.id === this.id) {
            if (previous.hasAttribute('open')) previous.hide();
            previous.remove();
          }
        });
        super.connectedCallback();
      }
    }
    customElements.define('hm-knee-detail', KneeDetail);
    document.addEventListener('shopify:section:unload', (event) => {
      document.querySelectorAll('hm-knee-detail').forEach((modal) => {
        if (modal.dataset.section === event.detail?.sectionId) {
          if (modal.hasAttribute('open')) modal.hide();
          modal.remove();
        }
      });
    }, true);
  });
})();
